<template>
  <!-- CPAP エスカレーション管理 -->
  <div id="EscalationList">
    <div id="container">
      <NaviBar v-bind:pageid='"EscalationList"'/>
      <div class="labelTitle lable">エスカレーション管理</div>
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>受付<br>番号</th>
              <td><input type="text" v-model="searchConditions.receiptNumber"/></td>
              <th>機種</th>
              <td><select v-model="searchConditions.model">
                <option v-for="model in cpapDeviceList" :value="model.itemCodes" :key="model.itemCodes">{{ model.itemName }}</option>
              </select></td>
              <th>シリアル</th>
              <td><input type="text" v-model="searchConditions.serial"/></td>
              <th>医療機関<br>コード</th>
              <td><input type="text" v-model="searchConditions.medicalInstitutionCode"/></td>
            </tr>
            <tr>
              <th>医療<br>機関名</th>
              <td><input type="text" v-model="searchConditions.medicalInstitutionName"/></td>
              <th>患者<br>コード</th>
              <td><input type="text" v-model="searchConditions.patientCode"/></td>
              <th>患者名</th>
              <td><input type="text" v-model="searchConditions.patientName"/></td>
              <th>患者名<br>カナ</th>
              <td><input type="text" v-model="searchConditions.patientNameKana"/></td>
            </tr>
            <tr>
              <th>プロック</th>
              <td>
                <select v-model="searchConditions.block">
                  <option value=""></option>
                  <option v-for="item in blockMaster" :key="item.code" :value="item.code">{{item.name}}</option>
                </select>
              </td>
              <th>担当支店</th>
              <td>
                <select v-model="searchConditions.branchOfficeCode">
                  <option value=""></option>
                  <option v-for="item in branchOfficeMaster" :key="item.code" :value="item.code">{{item.name}}</option>
                </select>
              </td>
              <th>営業<br/>担当者</th>
              <td><input type="text" v-model="searchConditions.salesStaffName"/></td>
              <th>コール<br/>種別</th>
              <td>
                <select v-model="searchConditions.callType">
                  <option :value="0"></option>
                  <option v-for="item in callTypeList" :key="item.code" :value="item.code">{{item.name}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>対応状況</th>
              <td><select v-model="searchConditions.escalationStatus">
                <option :value="0"></option>
                <option v-for="item in escalationStatusList" :key="item.code" :value="item.code">{{item.name}}</option>
              </select></td>
              <th>コール<br/>予定日</th>
              <td colspan="3"><input type="date" style="width:200px" v-model="searchConditions.scheduledDateStart"/> ～ <input type="date" style="width:200px" v-model="searchConditions.scheduledDateEnd"/></td>
            </tr>
            <tr>
              <th>コール<br/>実施日</th>
              <td colspan="3"><input type="date" style="width:200px" v-model="searchConditions.callImplementationDateStart"/> ～ <input type="date" style="width:200px" v-model="searchConditions.callImplementationDateEnd"/></td>
              <th>対応日</th>
              <td colspan="3"><input type="date" style="width:200px" v-model="searchConditions.implementationDateStart"/> ～ <input type="date" style="width:200px" v-model="searchConditions.implementationDateEnd"/></td>
            </tr>
          </table>
          <div class="searchButton-area">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area" v-if="data.length > 0">
          <b-button style="margin-right:10px;" class="clipboadCopyButton is-primary" @click="clipboardCopy('cpapEscalationListTable')">クリップボードにコピー</b-button>
          <div>
            <b-table
              id="cpapEscalationListTable"
              :data="data"
              :paginated="isPaginated"
              per-page="100"
              pagination-position="both"
              default-sort="patientCode"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
              <template slot-scope="props">
                <b-table-column field="escalationId" label="ID" width="80" centered sortable>
                  <a @click="showDetail(props.row)">{{props.row.escalationId}}</a>
                </b-table-column>
                <b-table-column field="receiptNumber" label="受付番号" width="80" centered sortable>{{props.row.receiptNumber}}</b-table-column>
                <b-table-column field="salesOfficeName" label="支店" width="100" centered sortable>{{props.row.salesOfficeName}}</b-table-column>
                <b-table-column field="medicalInstitutionName" label="医療機関名" width="200" sortable>{{props.row.medicalInstitutionName}}</b-table-column>
                <b-table-column field="patientName" label="患者名" width="150" sortable>{{props.row.patientName}}</b-table-column>
                <b-table-column field="itemCode" label="機種" width="140" sortable
                  >{{ convertDeviceModelName(props.row.deviceTypeCode, props.row.itemCode, props.row.inspectionDeviceId)}}</b-table-column
                >
                <b-table-column field="serial" label="シリアル" width="80" sortable>{{props.row.serial}}</b-table-column>
                <b-table-column field="callType" label="コール種別" width="100" sortable
                  >{{ convertCallType(props.row.callType)}}</b-table-column
                >
                <b-table-column field="scheduledDate" label="コール予定日" width="80" sortable>{{props.row.scheduledDate}}</b-table-column>
                <b-table-column field="callCompDate" label="コール実施日" width="80" sortable>{{props.row.callCompDate}}</b-table-column>
                <b-table-column field="escalationStatus" label="状況" width="60" sortable
                  >{{ convertEscalationStatus(props.row.escalationStatus) }}</b-table-column
                >
                <b-table-column field="philipsCorrespondenceDate" label="対応日" width="80" sortable>{{props.row.philipsCorrespondenceDate}}</b-table-column>
                <b-table-column field="salesStaffName" label="担当営業名" width="140" sortable>{{props.row.salesStaffName}}</b-table-column>
                <b-table-column field="mail" label="担当メールアドレス" width="90" sortable>{{props.row.mail}}</b-table-column>
              </template>
            </b-table>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import {
  cpapCallTypeList,
  cpapCallEscalationStatusList
} from "@/components/mock/base/const.js";
import NaviBar from "@/components/mock/philips/device/DeviceNaviBar";

export default {
  name: "EscalationList",
  methods: {
    clipboardCopy: function(elementId) {
      var btable = document.getElementById(elementId);
      var tableWrapper = btable.getElementsByClassName("table-wrapper")[0];
      var table = tableWrapper.getElementsByTagName("table")[0];
      var tbody = table.getElementsByTagName("tbody")[0];
      var tr = tbody.getElementsByTagName("tr")
      var records = []
      for (let i = 0; i < tr.length ;i++) {
        records.push(tr[i].innerText)
      }
      navigator.clipboard
        .writeText(records.join("\n"))
        .then(() => {
          this.showMessage("クリップボードにコピーしました。");
        })
        .catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
    },
    doSearch: function() {
      let isSearchParam = false
      let keys = Object.keys(this.searchConditions)
      for(let i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]+"" !="" && this.searchConditions[keys[i]] !="[]"){
          if((keys[i] == "callType" || keys[i] == "escalationStatus") && this.searchConditions[keys[i]]==0){
            continue
          }
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      var excuteApi = this.getCpapEscalationListPOST;
      var successCallBack = this.getCpapEscalationListPOSTSuccess;
      var errorCallBack = this.getCpapEscalationListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCpapEscalationListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      obj.model = JSON.parse(obj.model);
      return client.apis.internalCpap.getCpapEscalationListPOST({
        body:obj
      });
    },
    getCpapEscalationListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
    },
    getCpapEscalationListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    showDetail: function(rowData) {
      this.$router.push({
        name: "EscalationDetail",
        params: { searchConditions: this.searchConditions, escalationId: rowData.escalationId},
      });
    },

    findInspectionDevices() {
      let requestApi = this.findInspectionDevicesApi;
      let successCallBack = this.findInspectionDevicesSuccess;
      let errorCallBack = this.findInspectionDevicesError;
      this.apiCall(requestApi, successCallBack, errorCallBack);
    },
    findInspectionDevicesApi(client) {
      return client.apis.internalDeviceManagement.getDeviceKindsPOST({
        body: {}
      });
    },
    findInspectionDevicesSuccess(result) {
      this.inspectionDeviceList = result.obj;
    },
    findInspectionDevicesError(error) {
      // this.showErrorMessage(error);
    },

    convertDeviceModelName(deviceTypeCode, cpapDeviceCode, inspectionDeviceId) {
      let deviceName = "";
      let device = null;
      switch (deviceTypeCode) {
        case "CPAP":
          device = this.cpapDeviceList.find(item => item.itemCodes.indexOf(cpapDeviceCode) != -1);
          deviceName = device ? device.itemName : "";
          break;
        case "HST":
        case "CORP":
        case "HOLTER":
          device = this.inspectionDeviceList.find(item => item.value == inspectionDeviceId);
          deviceName = device ? device.kind : "";
          break;
        default:
          break;
      }
      return deviceName;
    },
    convertCallType(status) {
      let text = "";
      let finding = cpapCallTypeList.find(item => item.code == status);
      if (finding) {
        text = finding.name;
      }
      return text;
    },
    convertEscalationStatus(status) {
      let text = "";
      let finding = this.escalationStatusList.find(item => item.code == status);
      if (finding) {
        text = finding.name;
      }
      return text;
    },
  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    var searchConditions = {
      receiptNumber:"",
      model: "[]",
      serial:"",
      medicalInstitutionCode:"",
      medicalInstitutionName:"",
      patientCode:"",
      patientName: "",
      patientNameKana:"",
      block:"",
      branchOfficeCode:"",
      salesStaffName:"",
      callType:0,
      escalationStatus:0,
      scheduledDateStart:"",
      scheduledDateEnd:"",
      callImplementationDateStart:"",
      callImplementationDateEnd:"",
      implementationDateStart:"",
      implementationDateEnd:""
    }
    let cpapDeviceList = this.getCpapMaster();
    cpapDeviceList.unshift({itemCodes:"[]"})
    let branchOfficeMaster = this.getBranchOfficeMaster();
    let blockMaster = this.getBlockMaster();
    var callTypeList = cpapCallTypeList.filter(val => val.code < 10)
    return {
      data: [],
      cpapDeviceList,
      branchOfficeMaster,
      blockMaster,
      takeOverSearchParams,
      searchConditions,
      isPaginated : true,
      escalationStatusList: cpapCallEscalationStatusList,
      callTypeList
    };
  },
  components: {
    NaviBar
  },
  created() {
    this.findInspectionDevices();
  },
  mounted() {
    if(this.takeOverSearchParams) {
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  }
};
</script>

<style lang="scss" scoped>
.conditionTable th {
  width: 120px;
}
.conditionTable td {
  width: 400px;
}
a {
  text-decoration: underline;
}
.tag {
  width: 100px;
}
.operation-area {
  width: 1000px;
}
.operation-area::after {
  content: "";
  display: block;
  clear: both;
}
.operationButton {
  width:200px;
}
.modalTable {
  width: 600px;
}
.modalTable th {
  padding-top: 5px;
  font-size: 15px;
}
.red {
    font-weight: bold; 
    color: red;
}
.callButton {
  font-size:12px;
  height: 20px;
  margin-left:50px;
  float:right;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/escalation/EscalationList.vue